<template>
  <v-dialog v-model="show" max-width="900px" @click:outside="closeDialog" persistent>
    <v-card>
      <v-card-title class="headline">
        <span>Contenedor #{{ numContainer }}</span>
        <v-spacer></v-spacer>

      </v-card-title>

      <v-card-text class="pt-4">
        <!-- Product Manager Component -->
        <ProductManager 
          v-model="localProducts"
          :available-products="availableProducts"
          :loading="loading"
          :readonly="readonly"
          dense
        />

        <!-- Error -->
        <div v-if="error" class="red--text pa-4">
          <v-icon color="error">mdi-alert-circle</v-icon>
          {{ error }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>
        <v-btn 
          v-if="!readonly"
          color="success" 
          @click="saveAllChanges" 
          :loading="saving" 
          text
        >
          Guardar Cambios
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { packingListService } from "@/libs/ws/packingListService";
import { productoService } from "@/libs/ws/productoService";
import ProductManager from "@/components/ProductManager.vue";

export default {
  components: {
    ProductManager,
  },
  props: {
    value: Boolean,
    item: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      saving: false,
      packingList: null,
      localProducts: [], // Lista local editable
      originalProducts: [], // Backup para detectar cambios
      error: null,
      availableProducts: [],
    };
  },
  computed: {
    idTrip() {
      // Para Contenedores, el ID está en item.viajeIngreso.id
      // Para Rutas, el ID está directamente en item.id
      return this.item 
        ? (this.item.viajeIngreso ? this.item.viajeIngreso.id : this.item.id) 
        : null;
    },
    numContainer() {
      return this.item ? this.item.numContainer : "";
    },
    hasChanges() {
      return JSON.stringify(this.localProducts) !== JSON.stringify(this.originalProducts);
    },
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.loadPackingList();
        this.loadProducts();
      } else {
        this.resetModal();
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
    },
    resetModal() {
      this.packingList = null;
      this.localProducts = [];
      this.originalProducts = [];
      this.error = null;
    },
    loadPackingList() {
      if (!this.idTrip || !this.numContainer) return;

      this.loading = true;
      this.error = null;
      this.packingList = null;

      packingListService
        .findLatest(this.idTrip, this.numContainer)
        .then((response) => {
          console.log("Packing list FULL response:", response);
          
          // Verificar si el backend devuelve un mensaje de "no encontrado"
          if (response.title) {
            // No hay packing list, mostrar toast informativo
            this.$toast.info(response.title);
            this.packingList = null;
            this.localProducts = [];
            this.originalProducts = [];
          } else {
            // Hay packing list, cargar los datos
            this.packingList = response;
            // Inicializar lista local con copia profunda
            this.localProducts = JSON.parse(JSON.stringify(response.products || []));
            this.originalProducts = JSON.parse(JSON.stringify(response.products || []));
          }
          
          this.loading = false;
        })
        .catch((e) => {
          console.error("Error loading packing list:", e);
          
          // Error real de red o servidor
          const errorMessage = e.response?.data?.title || e.title || e.message || "Error al cargar el packing list";
          this.$toast.error(errorMessage);
          
          this.loading = false;
        });
    },
    loadProducts() {
      productoService
        .getAll()
        .then((response) => {
          console.log("Products FULL response:", response);
          // El response puede ser el array directamente o tener una propiedad products
          this.availableProducts = Array.isArray(response) ? response : (response.products || []);
          console.log("availableProducts set to:", this.availableProducts);
        })
        .catch((e) => {
          console.error("Error loading products:", e);
        });
    },

    saveAllChanges() {
      // Validaciones
      if (!this.localProducts || this.localProducts.length === 0) {
        this.$toast.error("Debe haber al menos un producto en la lista");
        return;
      }

      const invalidQuantity = this.localProducts.find(p => !p.quantity || p.quantity <= 0);
      if (invalidQuantity) {
        this.$toast.error("Todas las cantidades deben ser mayores a 0");
        return;
      }

      this.saving = true;

      const payload = {
        Id: this.packingList ? this.packingList.id : 0,
        idTrip: this.idTrip,
        numContainer: this.numContainer,
        products: this.localProducts.map(p => ({
          id: p.id,
          quantity: p.quantity,
        })),
      };

      packingListService
        .update(payload)
        .then((response) => {
          console.log("Packing list updated:", response);
          this.$toast.success(`Packing list actualizado.`);
          this.packingList = response;
          // Actualizar listas locales con la respuesta del servidor
          this.localProducts = JSON.parse(JSON.stringify(response.products || []));
          this.originalProducts = JSON.parse(JSON.stringify(response.products || []));
          this.saving = false;
          // Emitir evento para recargar lista en el componente padre
          this.$emit('loadPage');
          // Cerrar el modal después de guardar exitosamente
          this.closeDialog();
        })
        .catch((e) => {
          console.error("Error saving packing list:", e);
          this.$toast.error("Error al guardar el packing list");
          this.saving = false;
        });
    },

  },
};
</script>

<style scoped>
.headline {
  font-weight: 500;
}
</style>
